import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { Grid, IconButton, Typography } from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";

import TextFieldFormControl from "../../../../components/field/TextFieldFormControl";

import MiniButton from "../../../../components/base/MiniButton/MiniButton";

const PhoneRecord = React.memo((props) => {
  const { t } = useTranslation();;

  const onChange = (e) => {
    props.onChange(props.index, e);
  };

  const phoneRegex = /^\+48\s?\d{3}\s?\d{3}\s?\d{3}$/;

  return (
    <Grid item container spacing={1}>
      <Grid item xs={12}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item sm={6} xs={6} textAlign={"start"} display={"flex"}>
            <Typography variant="subtitle2" className="capitalize-first-letter">
              {t("clients.ClientPassportDialog.additional_phone")}
              {props.showNumber ? ` ${props.index + 1}` : ""}
            </Typography>
            {props.showDeleteButton && !props.readOnly && (
              <IconButton
                aria-label="delete"
                size="small"
                sx={{ padding: 0, paddingLeft: 0.5, color: "var(--alert)" }}
                onClick={() => {
                  props.onDelete(props.index);
                }}
              >
                <RemoveCircleIcon fontSize="inherit" />
              </IconButton>
            )}
          </Grid>
          <Grid item sm={6} xs={6} textAlign={"end"}>
            {props.showAddButton && (
              <MiniButton
                variant="contained"
                size="small"
                startIcon={<AddCircleOutlineOutlinedIcon />}
                onClick={props.onAdd}
              >
                {t("clients.ClientPassportDialog.add_phone")}
              </MiniButton>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <TextFieldFormControl
            name="phone_number"
            label={t("clients.ClientPassportDialog.phone_number")}
            value={props.phoneNumber}
            onChange={onChange}
            disabled={props.readOnly}
            isInvalid={props.phoneNumber && !phoneRegex.test(props.phoneNumber)}
        />
      </Grid>
    </Grid>
  );
});

PhoneRecord.propTypes = {
  index: PropTypes.number,
  onChange: PropTypes.func,
  showNumber: PropTypes.bool,
  showDeleteButton: PropTypes.bool,
  onDelete: PropTypes.func,
  showAddButton: PropTypes.bool,
  onAdd: PropTypes.func,
  readOnly: PropTypes.bool,
};

PhoneRecord.defaultProps = {
  showNumber: true,
  showDeleteButton: true,
  showAddButton: true,
  readOnly: false,
};

export default PhoneRecord;
